// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2026-03-18T17:47:05.191Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const InboundMeasuringTicketListView = lazy(() => import('@/procurement/InboundMeasuringTicketListView').then(m => ({ default: m.InboundMeasuringTicketListView })));
const InboundMeasuringTicketDetailView = lazy(() => import('@/procurement/InboundMeasuringTicketDetailView').then(m => ({ default: m.InboundMeasuringTicketDetailView })));
const SupplierListView = lazy(() => import('@/procurement/SupplierListView').then(m => ({ default: m.SupplierListView })));
const SupplierDetailView = lazy(() => import('@/procurement/SupplierDetailView').then(m => ({ default: m.SupplierDetailView })));

/**
 * Procurement Module Routes
 */
export const procurementRoutes = [
{ path: '/procurement/inboundmeasuringtickets',
element: <Suspense><InboundMeasuringTicketListView /></Suspense> },
{ path: '/procurement/inboundmeasuringtickets/:id',
element: <Suspense><InboundMeasuringTicketDetailView /></Suspense> },
{ path: '/procurement/suppliers',
element: <Suspense><SupplierListView /></Suspense> },
{ path: '/procurement/suppliers/:id',
element: <Suspense><SupplierDetailView /></Suspense> },
{ path: '/procurement/suppliers/template/new',
element: <Suspense><SupplierDetailView mode="template" /></Suspense> },
{ path: '/procurement/suppliers/template/:templateId',
element: <Suspense><SupplierDetailView mode="template" /></Suspense> }
];
